import { render, staticRenderFns } from "./headers-logo.vue?vue&type=template&id=1bea7f04&scoped=true"
import script from "./headers-logo.vue?vue&type=script&lang=js"
export * from "./headers-logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea7f04",
  null
  
)

export default component.exports